import { Link } from "react-router-dom";
import { Layers, Sparkles, ArrowRight } from "lucide-react";

import { Default } from "../../components/Default/Default";
import { ROUTES_APPLICATION_PATH } from "../../routes.constants";

const cards = [
  {
    ctx: {
      icon: Layers,
      title: "Qualificação do MIX",
      description: "Ranking de rede por grupo de produto e plano de mix por porte de loja.",
    },
    actions: { to: ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[1] },
  },
  {
    ctx: {
      icon: Sparkles,
      title: "Novo Mix Sugerido",
      description: "Oportunidades de inclusão e corte sugeridas pela IA, com retorno estimado.",
    },
    actions: { to: ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[2] },
  },
];

const OptionsCards = ({ actions, ctx }) => {
  const { to } = actions || {};
  const {
    icon: Icon,
    title,
    description
  } = ctx || {};

  return (
    <Link
      to={to}
      style={{
        display: "block", borderRadius: "16px", inlineSize: "fit-content",
        border: "1px solid #e2e8f0",
        backgroundColor: "#ffffff", padding: "24px",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)", 
        textDecoration: "none" }}>
      <div
        style={{
          marginBottom: "16px", display: "flex", height: "40px", width: "40px",
          alignItems: "center", justifyContent: "center", borderRadius: "12px",
          backgroundColor: "#ffedd5" }}>
        <Icon style={{ height: "20px", width: "20px", color: "#f97316" }} strokeWidth={2} />
      </div>

      <div style={{ marginBottom: "6px", display: "flex", alignItems: "center", gap: "6px" }}>
        <h3 style={{ fontSize: "15px", fontWeight: 600, color: "#0f172a", margin: 0 }}>
          {title}
        </h3>
        <ArrowRight style={{ height: "16px", width: "16px", color: "#f97316" }} strokeWidth={2} />
      </div>

      <p style={{ fontSize: "14px", lineHeight: "1.6", color: "#64748b", margin: 0 }}>
        {description}
      </p>
    </Link>
  );
}

export const MerchandiseOptions = () => {
  return (
    <Default fullPage>
      <section style={{ 
        minHeight: "100vh", display: "flex", flexDirection: "column",
        padding: "40px 160px", inlineSize: "70%", margin: "auto" }}>
        <div style={{ marginBottom: "24px" }}>
          <span style={{ fontSize: "12px", fontWeight: 500, letterSpacing: "0.02em", color: "#64748b" }}>
            SORTIMENTO
          </span>
          <h2 style={{ marginTop: "4px", fontSize: "24px", fontWeight: 700, color: "#0f172a" }}>
            Mercados &amp; Conveniências
          </h2>
          <p style={{ marginTop: "4px", fontSize: "14px", color: "#64748b" }}>
            Módulos de sortimento para o varejo alimentar e conveniência.
          </p>
        </div>

        <div
          style={{ display: "grid", gridTemplateColumns: "auto auto", gap: "16px" }}>
          {cards.map((card) => (
            <OptionsCards key={card.ctx.title} {...card} />
          ))}
        </div>
      </section>      
    </Default>
  );
}